import { colors } from "#app/theme/v2/colors";
import { Text } from "#components/atoms/Typographies/Text";
import { Icon } from "#shared/icons/Icon";

import { Modal } from "./Modal";

type Props = {
  opened: boolean;
  title: string;
  description: string;
  primaryText: string;
  secondaryText: string;
  closeText: string;
  onClose: () => void;
  onPrimary: () => void;
  onSecondary?: () => void;
  primaryDisabled?: boolean;
  primaryLoading?: boolean;
};

const WarningModal = ({
  opened,
  title,
  description,
  primaryText,
  secondaryText,
  closeText,
  onClose,
  onPrimary,
  onSecondary,
  primaryDisabled,
  primaryLoading,
}: Props) => (
  <Modal
    opened={opened}
    variant="warning"
    title={title}
    primaryText={primaryText}
    secondaryText={secondaryText}
    closeText={closeText}
    onClose={onClose}
    onPrimary={onPrimary}
    onSecondary={onSecondary}
    primaryDisabled={primaryDisabled}
    primaryLoading={primaryLoading}
    icon={<Icon name="fillDanger" size={32} />}
  >
    <Text size="small" color={colors.text.secondaryDefault} textAlign="center">
      {description}
    </Text>
  </Modal>
);

export { WarningModal };
